module.exports = __webpack_public_path__ + "img/test3.d0e72678.png";